// extracted by mini-css-extract-plugin
export default {"actionArea":"Card_actionArea__VagfG","cardContent":"Card_cardContent__YGKGA","TitleTextLabel":"Card_TitleTextLabel__wL1mG","SubtitleTextLabel":"Card_SubtitleTextLabel__bOswZ"};